<ng-container [ngSwitch]="appLoadingState$ | async">
  <app-error *ngSwitchCase="apiState.error" />
  <app-loader *ngSwitchDefault view="fullScreen" />
</ng-container>
